import React from "react";
import ReactApexChart from "react-apexcharts";



const HorizontalBarChart = ({ providers, totalEncounters, signedEncounters, unsignedEncounters, nonduplicatePatcount, CPTCount, UnitCount, maxvalue }) => {
  
  const xTickAmount=maxvalue/50;

 
  const chartOptions = {
    chart: {
      type: "bar",
      height: 850,
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        borderRadiusApplication: "end",
        horizontal: true,
        columnWidth: "100%",
        barHeight: "20px",
       
        dataLabels: {
          position: "top",
        },
      },
    },
    dataLabels: {
      enabled: true,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    xaxis: {
      tickAmount: xTickAmount,
      categories: providers,     
      labels: {
        style: {
          fontSize: "1rem",
        },
      },
    },
    yaxis: {
      min: 0,
      max: maxvalue,
      tickAmount: 10
    },
    fill: {
      opacity: 1
    },
    legend: {
      position: "top",
      fontSize: "18px"
    },
    tooltip: {
      enabled: true,
      followCursor: true, 
      y: {
        formatter: (val) => val,
        title: {
          formatter: (seriesName) => seriesName,
        },
      },
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        const value = series[seriesIndex][dataPointIndex];
        const seriesName = w.config.series[seriesIndex].name;
        return `<div style="padding: 8px; background: #fff; color: #000; border: 1px solid #ccc; border-radius: 4px;">
                  <strong>${seriesName}:</strong> ${value}
                </div>`;
      },
    },
  };
  
  
  return (
    <div className="mt-5">

        <div style={{width:'1100px', marginLeft:'200px' }}>
      <ReactApexChart
        options={chartOptions}
        
        series={[
          
          { name: "Total Encounters", data: totalEncounters },
          { name: "Signed Encounters", data: signedEncounters },
          { name: "Unsigned Encounters", data: unsignedEncounters },
          { name: "Total Patients", data: nonduplicatePatcount },
          { name: "Total CPTs", data: CPTCount },
          { name: "Total Units", data: UnitCount },
        ]}
        type="bar"
        height={850}
        
        
      />

     </div>
    </div>
  );
};

export default HorizontalBarChart;
